import PropTypes from "prop-types"
import React, {useEffect, useRef} from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import {withRouter} from "react-router-dom"
import {Link} from "react-router-dom"

//i18n
import {withTranslation} from "react-i18next"
import {useGlobal} from "../../util/Store"

const SidebarContent = props => {
    const [globalState, globalActions] = useGlobal()
    const ref = useRef()
    // Use ComponentDidMount and ComponentDidUpdate method symultaniously
    useEffect(() => {
        const pathName = props.location.pathname

        const initMenu = () => {
            new MetisMenu("#side-menu")
            let matchingMenuItem = null
            const ul = document.getElementById("side-menu")
            const items = ul.getElementsByTagName("a")
            for (let i = 0; i < items.length; ++i) {
                if (pathName === items[i].pathname) {
                    matchingMenuItem = items[i]
                    break
                }
            }
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem)
            }
        }
        initMenu()
    }, [props.location.pathname])

    useEffect(() => {
        ref.current.recalculate()
    })

    function scrollElement(item) {
        if (item) {
            const currentPosition = item.offsetTop
            if (currentPosition > window.innerHeight) {
                ref.current.getScrollElement().scrollTop = currentPosition - 300
            }
        }
    }

    function activateParentDropdown(item) {
        item.classList.add("active")
        const parent = item.parentElement
        const parent2El = parent.childNodes[1]
        if (parent2El && parent2El.id !== "side-menu") {
            parent2El.classList.add("mm-show")
        }

        if (parent) {
            parent.classList.add("mm-active")
            const parent2 = parent.parentElement

            if (parent2) {
                parent2.classList.add("mm-show") // ul tag

                const parent3 = parent2.parentElement // li tag

                if (parent3) {
                    parent3.classList.add("mm-active") // li
                    parent3.childNodes[0].classList.add("mm-active") //a
                    const parent4 = parent3.parentElement // ul
                    if (parent4) {
                        parent4.classList.add("mm-show") // ul
                        const parent5 = parent4.parentElement
                        if (parent5) {
                            parent5.classList.add("mm-show") // li
                            parent5.childNodes[0].classList.add("mm-active") // a tag
                        }
                    }
                }
            }
            scrollElement(item)
            return false
        }
        scrollElement(item)
        return false
    }

    return (
        <React.Fragment>
            <SimpleBar style={{maxHeight: "100%"}} ref={ref}>
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">

                        <li>
                            <Link to="/dashboard" className=" waves-effect">
                                <i className="bx bx-home-circle"></i>
                                <span>Dashboard</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/dashboard/businesses" className=" waves-effect">
                                <i className="bx bx-building-house"></i>
                                <span>Businesses</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/dashboard/users" className=" waves-effect">
                                <i className="fa fa-users"></i>
                                <span>Users</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/dashboard/bookings" className=" waves-effect">
                                <i className="bx bx-money"></i>
                                <span>Bookings</span>
                            </Link>
                        </li>

                         <li>
                            <Link to="/dashboard/services" className=" waves-effect">
                                <i className="bx bx-list-ol"></i>
                                <span>Services</span>
                            </Link>
                         </li>

                         <li>
                            <Link to="/dashboard/packages" className=" waves-effect">
                                <i className="bx bx-credit-card"></i>
                                <span>Packages</span>
                            </Link>
                        </li>


                         <li>
                            <Link to="/dashboard/countries" className=" waves-effect">
                                <i className="bx bx-globe"></i>
                                <span>Countries</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/dashboard/categories" className=" waves-effect">
                                <i className="bx bx-edit"></i>
                                <span>Categories</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/refunds" className=" waves-effect">
                                <i className="bx bx-undo"></i>
                                <span>Refunds</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/audit-logs" className=" waves-effect">
                                <i className="bx bx-history"></i>
                                <span>Audit Logs</span>
                            </Link>
                        </li>


                    </ul>
                </div>
            </SimpleBar>
        </React.Fragment>
    )
}

SidebarContent.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
